import bog from '../../utils/moreBog';

export class GwResponseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'GwResponseError';
  }
}

export const handleGwData = res => {
  if (res) {
    if (res.success) {
      return res.data || null;
    }
    bog.error(`GwResponseError: ${JSON.stringify(res)}`);
    throw new GwResponseError(res.message);
  }
  return null;
};

export const setPostBody = (data = {}) => data ;

const generateURLParams = (data = {}) => {
  const params = new URLSearchParams();
  Object.keys(data).forEach(key => {
    params.set(key, data[key]);
  });
  return params;
};

export const setGetParams = data => generateURLParams(data).toString();

const createBaseActions = (type, ...argNames) => (...args) => {
  const action = { type };
  argNames.forEach((arg, index) => {
    action[argNames[index]] = args[index];
  });
  return action;
};

export default createBaseActions;
